module.exports = __webpack_public_path__ + "resources/img/img_moai_backup_func.7507f6b5842f9b48571fddfa1bc4a340.png";